// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1Mhz5","col":"styles_col__2MAm8"};